import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import i18n from 'modules/core/lib/i18n'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  disabled?: boolean
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
  noPadding?: boolean
  autofocus?: boolean
  placeholder?: string
  noBackground?: boolean
}

const InlineSearch: React.FC<Props> = ({
  disabled = false,
  onSearch,
  search,
  noPadding = false, // TODO: This should be true
  autofocus,
  placeholder,
  noBackground,
}) => {
  const setPlaceholder = () => {
    return placeholder || i18n.t('common.filter_by_name')
  }

  const className = cx('search', {
    disabled,
    noPadding,
    noBackground,
    hasSearch: search.length > 0,
  })

  return (
    <label className={className}>
      <input
        disabled={disabled}
        type="text"
        className={styles.searchInput}
        onChange={onSearch}
        value={search}
        autoFocus={autofocus}
      />
      <div className={styles.searchLabel}>
        <Icon.Medium icon="search" />
        <div className={styles.searchLabelText}>{setPlaceholder()}</div>
      </div>
    </label>
  )
}

export default InlineSearch
